// extracted by mini-css-extract-plugin
module.exports = {"panel":"AcceptanceViewInfo_panel__3_SCn","selected":"AcceptanceViewInfo_selected__3gmZu"};